
import "cookieconsent";
import { Consent, Popup } from "cookieconsent";
import Debug from "debug";
import Vue from "vue";

const log = Debug("legend");

declare global {
  interface Window {
    cookieconsent: Consent;
  }
}

export default Vue.extend({
  name: "CookeConsent",

  render: h => h(),

  data() {
    return {};
  },

  props: {},

  mixins: [],

  components: {},

  computed: {},

  watch: {},

  methods: {
    initCookieConsent() {
      window.cookieconsent.initialise({
        window: `<div role="dialog" aria-live="polite" aria-label="cookieconsent" aria-describedby="cookieconsent:desc" class="cc-window {{classes}} ${this.$style.window}"><!--googleoff: all-->{{children}}<!--googleon: all--></div>`,
        palette: {
          popup: { background: "rgba(30,32,63,.9)" },
          button: {
            background: "#c5ab80",
            border: "transparent",
            text: "#fff"
          },
          highlight: {
            background: "transparent",
            border: "rgba(255,255,255,.5)",
            text: "rgba(255,255,255,.5)"
          }
        },
        theme: "classic",
        layouts: {
          legend: "{{header}}{{message}}{{compliance}}"
        },
        layout: "legend" as any,
        position: "bottom-right",
        compliance: {
          info: `<div class="cc-compliance cc-highlight ${this.$style.compliance}">{{deny}}{{allow}}</div>`,
          "opt-in":
            '<div class="cc-compliance cc-highlight">{{deny}}{{allow}}</div>',
          "opt-out":
            '<div class="cc-compliance cc-highlight">{{deny}}{{allow}}</div>'
        },
        type: "info",
        content: {
          header: "WE VALUE YOUR PRIVACY",
          allow: "Accept",
          deny: "Reject",
          href: "/policy"
        },
        elements: {
          header: `<span class="cc-header ${this.$style.header}">{{header}}</span>`,
          message: `<span id="cookieconsent:desc" class="cc-message ${this.$style.message}">We use cookies or similar technologies to improve user experience on our website and analyze our traffic. By clicking “Accept”, you agree to our website\’s cookies use as described in our <a href="/policy" target="_blank">Privacy Policy and Cookie Policy</a>.</span>`,
          allow: `<a aria-label="allow cookies" role=button tabindex="0" class="cc-btn cc-allow ${this.$style.button}">{{allow}}</a>`,
          deny: `<a aria-label="deny cookies" role=button tabindex="0" class="cc-btn cc-deny ${this.$style.button}">{{deny}}</a>`
        },
        revokable: false,
        onStatusChange: function(status) {
          // const popup = this as any;
          // console.log("status: %o", status);
          // console.log(
          //   popup.hasConsented() ? "enable cookies" : "disable cookies"
          // );
        }
      });
    }
  },

  created() {},

  mounted() {
    this.initCookieConsent();
  }
});
